import { render, staticRenderFns } from "./MelonTVSearchSchedule.vue?vue&type=template&id=1d84b83c&"
import script from "./MelonTVSearchSchedule.vue?vue&type=script&lang=js&"
export * from "./MelonTVSearchSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports